import { ADMSRDF, DCTERMS, VANN } from '../const/C';
import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';
import { SkosSchemesRequest, SkosSchemesCountRequest, SkosSchemesIRIRequest, SkosSchemeInCatalogRequest, 
    SkosNewConceptSchemeSimpleRequest, SkosConceptInSchemeCountRequest,   
    skosConceptInScheme, skosConceptInSchemeBroader, skosConceptInSchemeIdentifier,
    SkosNewConceptRequest,
    PredicatSubjectRequest, DeleteSubjectRequest, DeleteObjectRequest,
    LinkConceptInSchemeRequest, 
    RdfsLabelRequest, DcTermsTitleRequest,
    SkosConceptLinkCountRequest,
    SkosDescriptionRequest, AddPropertyInAssetRequest,
    RemovePropertyInAssetRequest, UpdateLiteralPropertyRequest, UpdateObjectPropertyRequest,
    NamedIndividualsRequest, DeleteLiteralValueInPropertyRequest, DeleteLinkValueInPropertyRequest,
    InsertTripleLiteralRequest,
    SkosInSchemeConceptsRequest, SkosNotInSchemeConceptsRequest, SkosConceptsRequest,
    AnySPARQLRequest, SkosUnlinkConceptInSchemeRequest,
    GraphIncludeSubjectRequest, CollectionByConceptsRequest } from '../virtuoso/request';
import { makeWhereFilterAdv } from '../virtuoso/filter';
import { getCountValue2 } from '../virtuoso/helper';

/** Проверяет, что есть назначенный условия */
const isConditionPresent = (conditions, rfilter) => {
    return (Array.isArray(conditions) && conditions.length>0) || (Array.isArray(rfilter) && rfilter.length>0);
}
/** Формирует запрос с учётом наличия условий. Если условяи есть, то делается cloneOriginal() 
 * и добавляются условия! */
const makeRequest = (pattern, conditions, rfilter) => {
    if (!isConditionPresent(conditions, rfilter))
        return pattern;
    const request = pattern.cloneOriginal();
    makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
    return request;
}

const buildLabelsQuery = (uris) => `
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>

SELECT ?uri ?label ?labelPredicate
WHERE {
  VALUES ?uri {
    ${uris.map((uri) => `<${uri}>`).join("\n    ")}
  }

  ?uri ?labelPredicate ?label .

  VALUES ?labelPredicate {
    skos:prefLabel
    skos:altLabel
    rdfs:label
  }

  FILTER(isLiteral(?label))
}
ORDER BY ?uri ?labelPredicate ?label
`;

/** Использование концептов  */
const buildThemeUsageCountSparql = (uris = []) =>  `
PREFIX dcat: <http://www.w3.org/ns/dcat#>

SELECT (COUNT(?dataset) AS ?themeUsageCount)
WHERE {
  VALUES ?concept {
    ${uris.map((uri) => `<${uri}>`).join("\n    ")}
  }

  ?dataset dcat:theme ?concept .
}
`;

//Загрузка описание SKOS схем и элементов
export const SkosRepository = {
    //Значение обязательного фильтра
    RFILTER: [],
    EMPTY: () => ({
        type: "SkosRepository.EMPTY",
    }),
    LOAD_STARTED: () => ({
        type: "SkosRepository.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "SkosRepository.LOAD_ERROR",
        error
    }),
    LOAD_DESCRIPTION: (IRI, description) => ({
        type: "SkosRepository.LOAD_DESCRIPTION",
        IRI, description
    }),
    LOAD_SCHEME_DETAILS: (iri, head, values) => ({
        type: "SkosRepository.LOAD_SCHEME_DETAILS",
        iri, values, head,
        predicates : (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[]
    }),
    LOAD_SCHEMES: (offset, limit, count, head, distinct, ordered, schemes) => ({
        type: "SkosRepository.LOAD_SCHEMES",
        offset, limit, count, head, distinct, ordered, schemes
    }),
    LOAD_NEXTSCHEMES: (offset, limit, head, distinct, ordered, schemes) => ({
        type: "SkosRepository.LOAD_NEXTSCHEMES",
        offset, limit, head, distinct, ordered, schemes
    }),
    USED_IN_CATALOG: (IRI, bindings) => ({
        type: "SkosRepository.USED_IN_CATALOG", scheme: IRI, values: bindings
    }),
    ADD_SCHEME: (iri, label, lang) =>({
        type: "SkosRepository.ADD_SCHEME",
        iri, label, lang
    }),
    REMOVE_SCHEME: (iri) => ({
        type: "SkosRepository.REMOVE_SCHEME",
        iri,
    }),
    CONDITIONS: conditions => ({
        type: "SkosRepository.CONDITIONS",
        conditions,
    }),
    /** Сохранить текущие настройки и выборанные элементы в стеке */
    PUSH : () => ({
        type: "SkosRepository.PUSH",
    }),

    /** Вернуть текущие настройки и выборанные элементы из стека */
    POP : () => ({
        type: "SkosRepository.POP",
    }),

    /** Список концептов (все - ALL, связанные - INSCHEMEи не связанные со схемой - NOTINSCHEME) */
    LOAD_CONCEPTS: (bindings, list) => ({
        type: "SkosRepository.LOAD_CONCEPTS",
        bindings, list
    }),

    /** Загрузить информацию об ConceptSheme в список. conditions - условия отбора,  
     * rfilter - обязательные условия отбора. */
    loadSchemes: (conditions=[], lang, rfilter=SkosRepository.RFILTER) => dispatch => {
        dispatch(SkosRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(SkosSchemesRequest, conditions, rfilter);
        request.request.offset = 0;
        request.request.limit = settings.defaultLimit;
        request.setLang(lang);
        const counter = makeRequest(SkosSchemesCountRequest, conditions, rfilter);
        //TODO Ошибка в определении левой части условия
        counter.fixVariable();
        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(SkosRepository.LOAD_SCHEMES(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить следующую порцию информации об ассетах */
    loadNextSchemes: (offset, conditions=[], lang, rfilter=SkosRepository.RFILTER) => dispatch => {
        dispatch(SkosRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(SkosSchemesRequest, conditions, rfilter);
        request.request.offset = offset;
        request.request.limit = settings.defaultLimit;
        request.setLang(lang);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosRepository.LOAD_NEXTSCHEMES(offset, request.request.limit, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    // Load all schemes IRIs for export.
    loadIRISchemes: (conditions=[], rfilter=SkosRepository.RFILTER)=> dispatch => {
        const options = {...settings.options};
        const request = makeRequest(SkosSchemesIRIRequest.cloneOriginal(), conditions, rfilter);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const bindings = response?.results?.bindings ?? [];
                const IRIs = [...new Set(
                    bindings
                        .map(item => item?.IRI?.value)
                        .filter(Boolean)
                )];
                return Promise.resolve(IRIs);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`loadIRIVocabs error ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получение списка IRI каталогов, в которых схема используется в таксономии */
    getUsedInCatalog: (IRI) => dispatch => {
        const options = {...settings.options};
        SkosSchemeInCatalogRequest.setConceptScheme(IRI);
        return ApiUtils.query(SkosSchemeInCatalogRequest, {}, options)
            .then (response =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosRepository.USED_IN_CATALOG(IRI, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosRepository.USED_IN_CATALOG(IRI, null));
                return Promise.reject(e);
            });
    
    },

    /** Добавление новой ConceptScheme. Для добавления используется прокси сервис в Liferay */
    addElement: (iri, type, label, lang) => dispatch => {
        const options = {...settings.options};
        SkosNewConceptSchemeSimpleRequest.setValues(iri, label, lang);
        SkosNewConceptSchemeSimpleRequest.setType(type);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': SkosNewConceptSchemeSimpleRequest.graph,
            'query': SkosNewConceptSchemeSimpleRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(SkosRepository.ADD_SCHEME(iri, label, lang));
                return Promise.resolve({iri, type, label, lang, response});
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление новой ConceptScheme. Для добавления используется прокси сервис в Liferay */
    addConcept: (scheme, concept, type, label) => dispatch => {
        const options = {...settings.options};
        console.log("SkosActions.js addConcept", SkosNewConceptRequest);
        SkosNewConceptRequest.setValues(concept, label, scheme);
        //SkosNewConcept.setType(type);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': SkosNewConceptRequest.graph,
            'query': SkosNewConceptRequest.sparql,
          }
        console.log("SkosActions.js addConcept", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //dispatch(SkosRepository.ADD_SCHEME(scheme, concept, type, label));
                return Promise.resolve({scheme, concept, type, label, response});
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Удаление элемента. Для удаления используется прокси сервис в Liferay */
    deleteElement: (iri) => dispatch => {
        DeleteSubjectRequest.setIRI(iri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteSubjectRequest.graph,
            'query': DeleteSubjectRequest.sparql,
          }
        //console.log("SkosActions.js deleteElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(SkosRepository.REMOVE_SCHEME(iri));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Удаление концепта элемента. Для удаления используется прокси сервис в Liferay */
    deleteConcept: (iri) => dispatch => {
        DeleteSubjectRequest.setIRI(iri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteSubjectRequest.graph,
            'query': DeleteSubjectRequest.sparql,
          }
        DeleteObjectRequest.setIRI(iri);
        const formData2 = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteObjectRequest.graph,
            'query': DeleteObjectRequest.sparql,
          }
          //console.log("SkosActions.js deleteElement", formData, options);
        return Promise.all([
                LiferayApiUtils.postToLifeRay721(formData, options),
                LiferayApiUtils.postToLifeRay721(formData2, options)
            ]).then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Исключение элемента. Используется прокси сервис в Liferay */
    unlinkElement: (scheme, concept) => dispatch => {
        SkosUnlinkConceptInSchemeRequest.setIRIs(scheme, concept);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': SkosUnlinkConceptInSchemeRequest.graph,
            'query': SkosUnlinkConceptInSchemeRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({scheme, concept, response});
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию об описаниии skos:ConceptScheme. Значение для предиката http://purl.org/dc/terms/description  */
    loadDescription: (iri) => dispatch => {
        const options = {...settings.options};
        SkosDescriptionRequest.setURI(iri);
        return ApiUtils.query(SkosDescriptionRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {bindings} = results;                
                dispatch(SkosRepository.LOAD_DESCRIPTION(iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },    

    /** Загрузить информацию о всех skos:Concept в список. */
    loadConcepts: () => dispatch => {
        const options = {...settings.options};        
        return ApiUtils.query(SkosConceptsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosRepository.LOAD_CONCEPTS(bindings, 'ALL'));
                return Promise.resolve(bindings);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию о всех skos:Concept, имеющих хотя бы одну связь со схемой. */
    loadInSchemeConcepts: () => dispatch => {
        const options = {...settings.options};        
        return ApiUtils.query(SkosInSchemeConceptsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosRepository.LOAD_CONCEPTS(bindings, 'INSCHEME'));
                return Promise.resolve(bindings);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию о skos:Concept не имеющих связь со схемой в список. */
    loadNotInSchemeConcepts: () => dispatch => {
        const options = {...settings.options};        
        return ApiUtils.query(SkosNotInSchemeConceptsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosRepository.LOAD_CONCEPTS(bindings, 'NOTINSCHEME'));
                return Promise.resolve(bindings);
            })
            .catch(e => { 
                dispatch(SkosRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить метки по заданным URI */
    loadLabels: (uris) => dispatch => {
        const options = {...settings.options};
        const request = AnySPARQLRequest.cloneOriginal();
        request.setSparql(buildLabelsQuery(uris));
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

        /** Загрузить метки по заданным URI */
    countThemeUsed: (uris) => dispatch => {
        const options = {...settings.options};
        const request = AnySPARQLRequest.cloneOriginal();
        request.setSparql(buildThemeUsageCountSparql(uris));
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

};


/**
 * Сформировать возможные значения IRI графов в Virtuoso.
 * Могут быть IRI карточки в конце #, значение поля dcterms:identifier, значение поля vann:preferredNamespaceUri
 */
const makeGraphContent = (iri, values) => {
    //console.log("AdmsActions.js makeGraphContent = (iri, values)", iri, values);
    const graphs = (iri.lastIndexOf('#')>0)?[iri+'Graph']:[iri+'#']
    if (values && Array.isArray(values)){
        const ids = values.filter(item => item.predicat.value== DCTERMS.IDENTIFIER);
        ids.forEach(uri => {
            if (uri.object.value.startsWith("http")){
                graphs.push(uri.object.value);
                if (uri.object.value.lastIndexOf('#')>0)
                    graphs.push(uri.object.value+'Graph');
                else
                    graphs.push(uri.object.value+'#');
            }
        });
        const ns = values.filter(item => item.predicat.value== VANN.PREFERREDNAMESPACEURI);
        ns.forEach(uri =>{            
            graphs.push(uri.object.value);
        });
    }
    return graphs.map(uri =>  { return {'iri': uri, "state": "recommended"}});
}

export const SkosScheme = {
    EMPTY: () => ({
        type: "SkosScheme.EMPTY",
    }),
    LOAD_STARTED: () => ({
        type: "SkosScheme.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "SkosScheme.LOAD_ERROR",
        error
    }),
    LOAD_SCHEME: (iri, head, values) => ({
        type: "SkosScheme.LOAD_SCHEME",
        iri, values, head,
        types: (values && Array.isArray(values))
            ?[...new Set(
                values.filter(item => item.predicat.value == "http://www.w3.org/1999/02/22-rdf-syntax-ns#type")
                      .map(item => item.object.value))
             ]
            :[], 
        predicates : (values && Array.isArray(values))
            ?[...new Set(values.map(item => item.predicat.value))]
            :[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[], 
        graphs: makeGraphContent(iri, values),
    }),

    LOAD_TAXONOMY: (taxonomy, concepts, schema, broader, identifier) => ({
        type: "SkosScheme.LOAD_TAXONOMY",
        taxonomy, concepts, schema, broader, identifier
    }),
    STATISTICS: (IRI, statistic) => ({
        type: "SkosScheme.STATISTICS", 
        IRI, statistic
    }),

    LOAD_LABELBYIRI: (iri, head, values) => ({
        type: "SkosScheme.LOAD_LABELBYIRI",
        iri, values, head,
    }),

    LOAD_DETAIL: (triplet, head, values, state) => ({
        type: "SkosScheme.LOAD_DETAIL",
        triplet, head, values, state,
        predicates : (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[],
    }),
    LOAD_CONCEPT: (concept, head, values, state) => ({
        type: "SkosScheme.LOAD_CONCEPT",
        predicates : (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[],
        concept, head, values, state,
    }),
    LINK_CONCEPT: (scheme, concept) => ({
        type: "SkosScheme.LINK_CONCEPT",
    }),

    /** Загрузить информацию о skos:ConceptScheme */
    loadScheme: (iri) => dispatch => {
        dispatch(SkosScheme.LOAD_STARTED());
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(iri);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosScheme.LOAD_SCHEME(iri, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    loadSelected: (iri) => dispatch => {
        return dispatch(SkosScheme.loadScheme(iri));
    },

    /** Список концептов привязанных к схеме */
    loadInScheme: schemeIri => dispatch => {
        const options = {...settings.options};
        skosConceptInScheme.setConceptScheme(schemeIri);
        dispatch(SkosScheme.LOAD_STARTED());
        return ApiUtils.query(skosConceptInScheme, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    // Загрузить информацию о метках 
    loadLabelByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        RdfsLabelRequest.setURI(IRI);
        return ApiUtils.query(RdfsLabelRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosScheme.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    // Загрузить информацию о заголовках
    loadTitleByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        DcTermsTitleRequest.setURI(IRI);
        return ApiUtils.query(DcTermsTitleRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosScheme.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получение детальной информации о триплете */
    onDetailElement: (triplet) => dispatch => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(triplet.object.value);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosScheme.LOAD_DETAIL(triplet, head, bindings, "loaded"));
                return Promise.resolve({triplet, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_DETAIL(triplet, [], [], "error"));
                return Promise.reject(e);
            });
    },

    /** Получение детальной информации о концепте */
    loadConcept: (concept) => dispatch => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(concept);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SkosScheme.LOAD_CONCEPT(concept, head, bindings, "loaded"));
                return Promise.resolve({concept, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_CONCEPT(concept, [], [], "error"));
                return Promise.reject(e);
            });
    },

    addProperty: (IRI, predicat, lang) => dispatch => {
        AddPropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': AddPropertyInAssetRequest.graph,
            'query': AddPropertyInAssetRequest.sparql,
          }
        //console.log("AdmsActions.js addProperty", IRI, predicat, lang, AddPropertyInAssetRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("AdmsActions.js addProperty", IRI, predicat, lang, AddPropertyInAssetRequest.request, response);
                //dispatch(SkosScheme.ADD_DISTRIBUTION(iri, response));
                return Promise.resolve({IRI, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    insertTriple: (subject, predicat, value, lang=undefined) => dispatch => {
        InsertTripleLiteralRequest.setValues(subject, predicat, value, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':InsertTripleLiteralRequest.graph,
            'query': InsertTripleLiteralRequest.sparql,
          }
        //console.log("AdmsActions.js insertTriple", subject, predicat, value, lang, InsertTripleRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("AdmsActions.js insertTriple", subject, predicat, value, lang, InsertTripleRequest.request, response);
                return Promise.resolve({subject, predicat, value, lang});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    removeProperty: (IRI, predicat) => dispatch => {
        //console.log("AdmsActions.js removeProperty", IRI, predicat, RemovePropertyInAssetRequest);
        RemovePropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': RemovePropertyInAssetRequest.graph,
            'query': RemovePropertyInAssetRequest.sparql,
          }
        //console.log("AdmsActions.js removeProperty", IRI, predicat, RemovePropertyInAssetRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    updateLiteralProperty: (IRI, predicat, oldValue, newValue, lang) => dispatch => {
        //console.log("AdmsActions.js updateLiterlProperty", IRI, predicat, oldValue, newValue, lang, UpdateLiteralPropertyRequest);
        UpdateLiteralPropertyRequest.setValues(IRI, predicat, oldValue, newValue, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateLiteralPropertyRequest.graph,
            'query': UpdateLiteralPropertyRequest.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", UpdateLiteralPropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },

    updateObjectProperty: (IRI, predicat, oldValue, newValue) => dispatch => {
        //console.log("AdmsActions.js updateObjectProperty", IRI, predicat, oldValue, newValue, UpdateObjectPropertyRequest);
        UpdateObjectPropertyRequest.setValues(IRI, predicat, oldValue, newValue);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateObjectPropertyRequest.graph,
            'query': UpdateObjectPropertyRequest.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", UpdateObjectPropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },
 
    /** Загрузить информацию об индивидуалах. rdfType - IRI типf */
    loadNamedIndividuals: (rdfType, graph) => {
        const options = {...settings.options};
        NamedIndividualsRequest.setType(rdfType);
        return ApiUtils.query(NamedIndividualsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({rdfType, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    }, 

    deleteValueInProperty: (IRI, predicat, value) => dispatch => {
        const request = (value && value.startsWith("http")) ? DeleteLinkValueInPropertyRequest:DeleteLiteralValueInPropertyRequest;
        //console.log("AdmsActions.js deleteValueInObjectProperty", IRI, predicat,value, request);
        request.setValues(IRI, predicat, value);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': request.graph,
            'query': request.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", request);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },

    /** Загрузка концептов, входящих в схему. */
    loadTaxonomy: taxonomy => dispatch => {
        const options = {...settings.options};
        skosConceptInScheme.setConceptScheme(taxonomy);
        skosConceptInSchemeBroader.setConceptScheme(taxonomy);
        skosConceptInSchemeIdentifier.setConceptScheme(taxonomy);
        RdfsLabelRequest.setURI(taxonomy);
        
        return Promise.all([
                ApiUtils.query(skosConceptInScheme, {}, options),
                ApiUtils.query(RdfsLabelRequest, {}, options),
                ApiUtils.query(skosConceptInSchemeBroader, {}, options),
                ApiUtils.query(skosConceptInSchemeIdentifier, {}, options),
            ]) .then ((response) =>{
                //console.log("AdmsActions.js loadTaxonomy: taxonomy => dispatch =>", response);
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                dispatch(SkosScheme.LOAD_TAXONOMY(
                    taxonomy, 
                    bindings, 
                    response[1].results.bindings, 
                    response[2].results.bindings.reduce((result, item) => {
                        result[item.IRI.value] = item.broader.value;
                        return result;
                    }, {}),
                    response[3].results.bindings.reduce((result, item) => {
                        result[item.IRI.value] = item.identifier.value;
                        return result;
                    }, {}))
                    );
                return Promise.resolve({taxonomy, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    getConceptCountInScheme: (IRI) => dispatch => {
        const options = {...settings.options};
        SkosConceptInSchemeCountRequest.setConceptScheme(IRI);
        console.log("SkosActions.js getConceptCountInScheme", SkosConceptInSchemeCountRequest.request);
        return ApiUtils.query(SkosConceptInSchemeCountRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const count =(Array.isArray(bindings) && (bindings.length>0))?bindings[0].cnt.value: 0;
                //Пример ответа { "head": { "link": [], "vars": ["theme", "cnt"] },
                // "results": { "distinct": false, "ordered": true, "bindings": [
                //      { "theme": { "type": "uri", "value": "http://hbz.ru/adms/internal" }, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "7" }} ] } }
                //dispatch(SkosScheme.STATISTICS(IRI, {count}));
                return Promise.resolve({IRI, count, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    
    /** Загрузка количества доступных элементов по таксономии. Заполняет vadms.statistics */
    loadTaxonomyConceptCount: (conceptIRI, lang, graph, rfilter=SkosRepository.RFILTER, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = (isConditionPresent(conditions, rfilter))? SkosConceptLinkCountRequest().cloneOriginal():SkosConceptLinkCountRequest();
        request.setConceptIRI(conceptIRI);
        if (isConditionPresent(conditions, rfilter))
            makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
        //console.log("loadTaxonomyConceptCount: conceptIRI => dispatch => { SkosConceptLinkCountRequest", SkosConceptLinkCountRequest.request);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const count =(Array.isArray(bindings) && (bindings.length>0))?bindings[0].cnt.value: 0;
                //Пример ответа { "head": { "link": [], "vars": ["theme", "cnt"] },
                // "results": { "distinct": false, "ordered": true, "bindings": [
                //      { "theme": { "type": "uri", "value": "http://hbz.ru/adms/internal" }, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "7" }} ] } }
                dispatch(SkosScheme.STATISTICS(conceptIRI, {count}));
                return Promise.resolve({conceptIRI, count, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },


    linkConcept: (scheme, concept) => dispatch => {
        LinkConceptInSchemeRequest.setValue(scheme, concept);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': LinkConceptInSchemeRequest.graph,
            'query': LinkConceptInSchemeRequest.sparql,
            }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then (response =>{
                dispatch(SkosScheme.LINK_CONCEPT(scheme, concept));
                return Promise.resolve({scheme, concept, response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    
    inGraph: (scheme) => dispatch => {        
        const options = {...settings.options};
        const request = GraphIncludeSubjectRequest.cloneOriginal();
        request.setIRI(scheme)
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    
    /** Загрузка количества доступных элементов по таксономии. Заполняет vadms.statistics */
    getCollectionByConcepts: (conceptIRIs, graph) => dispatch => {
        const options = {...settings.options};
        CollectionByConceptsRequest.setIRIs(conceptIRIs);
        //console.log("loadTaxonomyConceptCount: conceptIRI => dispatch => { SkosConceptLinkCountRequest", SkosConceptLinkCountRequest.request);
        return ApiUtils.query(CollectionByConceptsRequest, {}, options)
            .then ((response) =>{
                return Promise.resolve({response});
            })
            .catch(e => { 
                dispatch(SkosScheme.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
   
}